import React from "react";

const CommonGridHeader = ({
    title = "List Orders",
    fields = [],
    selectedFields = [],
    onFieldChange,
    onReset,
}) => {

    const isChecked = (field) => selectedFields.includes(field.key);

    return (
        <div className="card mb-3">
            <div className="card-body">
                {/* <h5 className="mb-3">{title}</h5> */}
                <div className="fw-bold mb-2">
                    Show Fields :
                </div>

                <div className="d-flex flex-wrap gap-3">

                    {fields.map((field) => (
                        <div
                            className="form-check"
                            key={field.key}
                        >
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isChecked(field)}
                                onChange={() => onFieldChange(field.key)}
                            />

                            <label className="form-check-label">
                                {field.label}
                            </label>
                        </div>
                    ))}

                </div>

                <div className="mt-3">
                    <button
                        className="btn btn-danger btn-sm"
                        onClick={onReset}
                    >
                        Reset
                    </button>
                </div>

            </div>
        </div>
    );
};

export default CommonGridHeader;